import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ENDPOINTS } from 'config/endpoints';
import CronoError from 'crono-fe-common/types/error';
import { EventOutcome } from 'crono-fe-common/types/event';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { invalidateActivitiesQueries } from 'hooks/services/event/useActivitiesSearch';
import { invalidateTimelineQueries } from 'hooks/services/timeline/useSearchTimeline';
import client from 'utils/clients/client';

const ENDPOINT = ENDPOINTS.events.event;

export interface LogEventPayload {
  accountId: string;
  prospectId: string;
  opportunityId?: string | null;
  title: string;
  startTime: string;
  endTime?: string | null;
  isAllDay: boolean;
  location?: string | null;
  description?: string | null;
  conferenceLink?: string | null;
  attendeeEmails: string[];
  outcome: EventOutcome;
  externalValues?: Record<number, string | null>;
}

const insertEvent = (payload: LogEventPayload) => {
  const request: Request = {
    url: ENDPOINT,
    config: {
      method: 'post',
      data: { data: payload },
    },
  };
  return client(request);
};

export const useLogEvent = () => {
  const queryClient = useQueryClient();

  return useMutation<Response<null>, CronoError, LogEventPayload>(insertEvent, {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [ENDPOINT] });
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.account.main, variables.accountId],
      });
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.account.search.main],
      });
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.prospect.main, variables.prospectId],
      });
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.prospect.search.main],
      });
      invalidateActivitiesQueries(queryClient);
      invalidateTimelineQueries(queryClient);
    },
  });
};
